import { Activity, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Selector } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { FormActivity } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

export interface DocumentResult {
	readonly stateChanged: boolean;
	readonly returnValue: Activity.Data.Document | undefined;
}
export function selectDocument(activityId: string): Selector<DocumentResult> {
	const selectActivity = ActivitySelectors.activityById(activityId);

	return state => {
		const dataHolder = Activity.findDefaultDataHolder(selectActivity(state));
		if (dataHolder?.loadingState === "error") {
			throw new Error("Cannot access activity data due to error.");
		}

		if (dataHolder?.loadingState !== "loaded") {
			return { stateChanged: false, returnValue: undefined };
		}

		if (!FormActivity.Data.SingleDocumentData.isInstance(dataHolder.data)) {
			throw new Error("Cannot access activity data due to error.");
		}

		return { stateChanged: true, returnValue: dataHolder.data.document };
	};
}
